<template>
  <svg 
    :width="width" 
    :height="height"
    :viewBox="viewBox"
    fill="none" xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse cx="23.8379" cy="23.9283" rx="23.8379" ry="23.9283" transform="rotate(-.3886 213.02139 -220.47297) skewX(-.00345)" fill="#fff" stroke="#000" stroke-width="1.5"/>
    <ellipse cx="22.3736" cy="22.4584" rx="22.3736" ry="22.4584" transform="rotate(-.3886 426.80613 -434.88838) skewX(-.00345)" fill="#000" stroke="#fff" stroke-width=".75"/>
    <path d="m39.2489 17.1904-27.298 13.9169-.1853-2.6123 1.7504-.8962c.0004-.0002.0033-.0016.0083-.0043l25.6371-13.126.0875 2.7219ZM25.496 13.5244c2.5928 0 5.0035.944 6.9352 2.3813l-2.3117 1.1644c-1.3735-.799-2.9221-1.1644-4.6235-1.1644-5.1542 0-9.3496 4.0006-9.3496 9.1784v1.1679l-2.622 1.3423c.0738-.0402.5938-.3979.413-2.4246 0-6.4073 5.1513-11.6453 11.5586-11.6453ZM11.7823 33.2473l27.298-13.9169.1853 2.6123-1.7504.8962a.41224.41224 0 0 0-.0083.0043l-25.6371 13.126-.0875-2.7219ZM25.5352 36.9133c-2.5928 0-5.0035-.944-6.9351-2.3813l2.3117-1.1644c1.3735.799 2.9221 1.1644 4.6234 1.1644 5.1542 0 9.3497-4.0006 9.3497-9.1784v-1.1679l2.6219-1.3424c-.0737.0402-.5938.398-.413 2.4247 0 6.4073-5.1513 11.6453-11.5586 11.6453Z" fill="#fff"/>
  </svg>
</template>
<script setup>
  const props = defineProps({
    constant: {
      type: Object,
      default: () => {}
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    size: {
      type: Number,
      default: 0
    },
  })

  const viewBox = `0 0 51 50`
  const width = props.width * props.size
  const height = props.height * props.size
</script>